import axios, { AxiosResponse } from "axios";

const responseBody = (response: AxiosResponse) => response.data;
const requests = {
	get: (url: string) => axios.get(url).then(responseBody),
	post: (url: string, body: object) => axios.post(url, body).then(responseBody),
	put: (url: string, body: object) => axios.put(url, body).then(responseBody),
	delete: (url: string) => axios.delete(url).then(responseBody),
};

const api = {
  	//User
	findByPhoneOrUserId: (phoneOrUserId: string) => requests.post('admin/api/user/findByPhoneOrUserId',{phoneOrUserId:phoneOrUserId}),

	getIsUser: (userId: string) => requests.get(`admin/rest/getIsUser?phone=${userId}`),
	searchCompany: (comSearchQuery: string) => requests.get(`admin/rest/searchCompany?query=${comSearchQuery}`),
	login: (phoneOrUserId: string, auth: string, inputPassword: string) => requests.post('admin/api/user/login',{phoneOrUserId:phoneOrUserId, auth:auth, inputPassword:inputPassword}),
	getLoginUser: () => requests.post('admin/api/user/getLoginUser',{}),
	checkKakaoId: (kakaoId:string) => requests.post('admin/api/user/loginByKakaoId',{kakaoId:kakaoId}),
	checkPhone: (phone:string) => requests.post('admin/api/user/loginByPhone',{phone:phone}),
	//Env
	getEnv: () => requests.post(`admin/api/env/getEnv`,{}),
	matchNfc: (serialNumber:string) => requests.post(`admin/api/env/matchNfc`,{serialNumber:serialNumber}),
	getPccInfo: () => requests.post(`admin/api/env/getPccInfo`,{}),

	getAdminEnv: () => requests.post(`api/env/getEnv`,{}),
	getAdminPccInfo: () => requests.post(`api/env/getPccInfo`,{}),
	adminLogin: (phoneOrUserId: string, password:string) => requests.post('api/user/login',{phoneOrUserId:phoneOrUserId,inputPassword:password}),

}

export default api;
